import { NgTemplateOutlet } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import type { FormControl } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { OfferSelectComponent } from '@core/offers-smart-ui';
import type { OfferSelectOption } from '@core/offers-ui';
import { BoxComponent, FormFieldComponent, LabelComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-job-field',
  templateUrl: './evaluation-job-field.component.html',
  styleUrl: './evaluation-job-field.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgTemplateOutlet,
    BoxComponent,
    ReactiveFormsModule,
    TranslatePipe,
    FormFieldComponent,
    LabelComponent,
    OfferSelectComponent,
  ],
})
export class EvaluationJobFieldComponent {
  public readonly control = input.required<FormControl<number | null>>();
  public readonly offers = input<OfferSelectOption[]>([]);
  public readonly labelKey = input<string>();
  public readonly hasBox = input<boolean>(true);
  public readonly selectShadow = input<boolean>(false);
}
